<template>
	<label
		class="ms-input-search flex ms-editor"
		:class="{
			isValid: errorProvider.isValid,
			'input-disabled': disabled,
			'pr-0': subtext,
			focused: focused,
			'grey-icon': colorGrey,
		}"
	>
		<input
			class="ms-input-item ms-input-item-ellipsis"
			:placeholder="placeholder"
			v-model="internalText"
			:disabled="disabled"
			:readonly="readOnly"
			:maxlength="maxLength"
			ref="input"
			:class="{
				'input-disabled': disabled,
				'input-focused': focused,
				'grey-icon': colorGrey,
			}"
			v-on="listeners"
		/>
		<div
			class="icon-input"
			v-tooltip="{
				content: errorProvider.message,
				show: focused,
				classes: `error`,
				autoHide: false,
				placement: 'bottom-end',
			}"
			v-if="errorProvider.isValid"
		>
			<div class="mi mi-24 mi-red-tick"></div>
		</div>
		<div
			v-if="icon && isHoverIcon"
			:class="{ 'icon-wrraper': isHoverIcon }"
			@click.stop="onIconClick"
		>
			<div :class="['icon-input', 'mi-new-v2 mi-16', icon]"></div>
		</div>
		<div
			:class="['icon-input', 'mi-new-v2 mi-16', icon]"
			v-if="icon && !isHoverIcon"
			@click.stop="onIconClick"
		></div>
		<div v-if="subtext" class="subtext">{{ subtext }}</div>
	</label>
</template>
<script>
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
export default {
	extends: msBaseComponent,
	name: 'msInputSearch',
	props: {
		line: {
			type: Boolean,
			default: false,
		},
		/**
		 * V-model bắn ra ngoài binding 2 chiều
		 */
		value: {
			default: null,
		},
		/**
		 * Hiện thị chũ mờ ở dưới ô input
		 * Created by LTDAT(22.06.2020)
		 */
		placeholder: {
			default: null,
			type: [Number, String],
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		//class chứa icon
		icon: {
			default: null,
			type: String,
		},
		//input chỉ đọc không cho nhập
		readOnly: {
			default: false,
			type: Boolean,
		},
		//Giới hạn nhập của ô input
		maxLength: {
			default: null,
			type: Number,
		},
		subtext: {
			default: null,
			type: String,
		},
		colorGrey: {
			default: false,
			type: Boolean,
		},
		isHoverIcon: {
			default: false,
			type: Boolean,
		},
		/**
		 * Khi true, chỉ validate khi blur ra ngoài ô input, không validate trong quá trình đang nhập liệu.
		 * Dùng cho các trường hợp rule validate định dạng phức tạp (ví dụ: mã số thuế)
		 * để tránh hiển thị lỗi khi người dùng chưa nhập xong.
		 */
		validateOnBlur: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			internalText: this.value,
			focused: false,
			displayValue: null,
		};
	},
	computed: {
		listeners() {
			return {
				blur: (e) => {
					this.onBlur(e);
				},
				focus: (e) => {
					this.onFocus(e);
				},
				change: (e) => {
					this.$emit('change', this.internalText, e);
				},
				keydown: (e) => {
					this.$emit('keydown', e);
				},
			};
		},
	},
	methods: {
		//Sự kiện focus vào ô input
		onFocus(e) {
			const me = this;
			me.focused = true;
			me.$emit('focus', e);
		},
		//Sự kiên blur ra ngoài ô input
		onBlur(e) {
			const me = this;
			me.focused = false;
			// Khi validateOnBlur = true, chỉ thực hiện validate tại đây (khi blur ra ngoài)
			if (me.validateOnBlur) {
				me.$nextTick(() => {
					me.validate();
				});
			}
			me.$emit('blur', e);
		},
		//Reset lại giá trị về ban đầu
		reset() {
			const me = this;
			me.internalText = null;
			me.displayValue = null;
		},
		//Set giá trị cho ô input
		setValue(value) {
			const me = this;
			me.internalText = value;
		},
		onIconClick() {
			const me = this;
			if (me.disabled) return;

			// Emit sự kiện search để parent component bắt và xử lý
			me.$emit('onIconClick');
		},
	},
	watch: {
		internalText: {
			handler(newVal, oldVal) {
				const me = this;
				me.$emit('input', newVal);
				// Khi validateOnBlur = true, không validate trong quá trình đang nhập liệu,
				// validate sẽ được thực hiện trong sự kiện onBlur
				if (!me.validateOnBlur) {
					me.$nextTick(() => {
						me.validate();
					});
				}
			},
		},
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.setValue(newVal);
			},
		},
		disabled: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.validate();
				}
			},
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msInputSearch.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msInputSearch.scss';
}
.icon-wrraper {
	display: flex;
	align-items: center;
	justify-content: center;
}
.icon-wrraper:hover {
	width: 32px;
	height: 32px;
	border-radius: 50%;
	background: #ccc;
}
</style>
